<template>
  <div class="pa-3 neu-glow">
    <v-form @submit.prevent="$v.$invalid ? () => {} : submit()" ref="form">
        <v-snackbar top right v-model="snackbar" :color="snackbar_color" :timeout="2000" >
          <span>{{snackbar_message}}</span>
        </v-snackbar>
        <v-card class="neu-glow elevation-8 pb-5">
          <v-card-title primary-title>
            <div class="text-h5">Impostazioni Direct Booking</div>
            <v-spacer></v-spacer>
            <div>
              <!--
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading_update" @click.stop="saveTemplate()">
                    <v-icon color="error">mdi-content-save</v-icon>
                  </v-btn>
                </template>
                <span>Salva</span>
              </v-tooltip>
              -->
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_instruction=true">
                    <v-icon color="info">mdi-help-circle</v-icon>
                  </v-btn>
                </template>
                <span>Istruzioni</span>
              </v-tooltip>                
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon  fab small class="neu-glow mr-2" :loading="loading" @click.stop="getData('refresh')">
                    <v-icon color="info">mdi-sync-circle</v-icon>
                  </v-btn>
                </template>
                <span>Refresh</span>
              </v-tooltip>              
            </div>           
          </v-card-title>
          <v-row v-if="loading">
            <v-col class="text-center">
              <v-progress-linear
                color="info"
                height="10"
                indeterminate
                striped
              ></v-progress-linear>
            </v-col>
          </v-row>          
          <v-row v-else class="mx-5">
            <v-col cols="12" lg="6" class="order-0 order-xl-0">
              <v-card class="neu-glow mb-3">
                <v-card-title class="text-h5 mb-3 blue-grey darken-1">
                  Immagini Form Prenotazione Online
                </v-card-title>
                <v-row class="mx-2" v-for="(i,ii) in WA_DB.filter(w=>w.optionId.includes('logo'))" :key="ii">
                  <template>
                    <v-col cols="12" class="py-1"><div>{{i.description}}</div> </v-col>
                    <template v-if="i.value" >
                      <v-col class="d-flex align-center"> 
                        <v-img 
                          class="elevation-8 mb-3" 
                          :key="ii" 
                          :src="'https://ibookrestaurant.com/static/users/pictures/'+i.path+'/'+i.value" 
                          :lazy-src="'https://ibookrestaurant.com/static/users/pictures/'+i.path+'/'+i.value"
                          :max-width="i.size.split('x')[0]/2"
                          :max-height="i.size.split('x')[1]/2"
                          :style="i.optionId.includes('W')?'background-color:#000':''"
                        >
                        </v-img>
                      </v-col>
                    </template>
                    <template v-else>
                      <v-col cols="6"  class="d-flex align-center">    
                        <v-img 
                          class="elevation-8 mb-3" :key="ii" 
                          src="https://ibookrestaurant.com/static/users/pictures/db/empty_200_70.png"
                          lazy-src="https://ibookrestaurant.com/static/users/pictures/db/empty_200_70.png" 
                          :max-width="i.size.split('x')[0]/2"
                          :max-height="i.size.split('x')[1]/2"
                          :style="i.optionId.includes('W')?'background-color:#000':''"
                        >
                        </v-img>
                      </v-col>
                    </template>
                    <v-col cols="3"  class="d-flex justify-center align-center">  
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="setPictureName(i)">
                            <v-icon color="info">mdi-image-edit</v-icon>
                          </v-btn>
                        </template>
                        <span>Cambia Immagine</span>
                      </v-tooltip>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="restoreImage(i)">
                            <v-icon color="warning">mdi-image-remove</v-icon>
                          </v-btn>
                        </template>
                        <span>Ripristina Immagine</span>
                      </v-tooltip>               
                    </v-col>
                  </template>
                </v-row>
              </v-card>              
            </v-col> 
            <v-col cols="12" lg="6" class="order-0 order-xl-0">
              <v-card class="neu-glow mb-3">
                <v-card-title class="text-h5 mb-3 blue-grey darken-1">
                  Immagini Slide Prenotazione Online
                  <v-spacer></v-spacer>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="setPictureName(i)">
                        <v-icon color="info">mdi-image-edit</v-icon>
                      </v-btn>
                    </template>
                    <span>Inserisci Immagine</span>
                  </v-tooltip>
                </v-card-title>
                <template v-if="WA_DB&&WA_DB.find(w=>w.optionId=='carouselImages').value">
                <v-row class="mx-2" v-for="(i,ii) in WA_DB.find(w=>w.optionId=='carouselImages').value.split(',')" :key="ii">
                  <template>
                    <v-col cols="10" class="py-1">
                      <v-col class="d-flex align-center"> 
                        <v-img 
                          class="elevation-8 mb-3" 
                          :key="ii" 
                          :src="'/static/users/pictures/slides/'+i" 
                          :lazy-src="'/static/users/pictures/slides/'+i"
                          style="height:300px"
                        >
                        </v-img>
                      </v-col>
                    </v-col>
                    <v-col cols="1"  class="d-flex justify-center align-center">  
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="restoreImage(i)">
                            <v-icon color="warning">mdi-image-remove</v-icon>
                          </v-btn>
                        </template>
                        <span>Cancella Immagine</span>
                      </v-tooltip>               
                    </v-col>
                  </template>
                </v-row>
                </template>
              </v-card>              
            </v-col>             
            <v-col cols="12" lg="6" class="order-1 order-xl-1">
              <v-card class="neu-glow" :class="$vuetify.breakpoint.lgAndUp?' mb-3':' my-3'">
                <v-card-title class="text-h5 mb-3 blue-grey darken-1">
                  Parametri Form Prenotazione Online
                </v-card-title>
                <v-row class="mx-2" v-for="(i,ii) in WA_DB.filter(w=>w.optionId.substring(0,4)!='logo')" :key="ii">
                  <v-col cols="11" v-if="i.dataType=='nvarchar'" class="d-flex align-center">  
                      <v-textarea 
                        v-if="i.inputType=='textarea'"
                        counter
                        :label="i.description"
                        :name="i.optionId"
                        @input.native="save"
                        outlined
                        :reverse="i.dataType!='nvarchar'"
                        v-model="i.value"
                        persistent-placeholder
                        hide-details
                        :readonly="!i.editableByUser"
                      >
                      </v-textarea>
                      <v-text-field 
                        v-else 
                        counter
                        :label="i.description"
                        :name="i.optionId"
                        @input.native="save"
                        outlined
                        :reverse="i.dataType!='nvarchar'"
                        v-model="i.value"
                        persistent-placeholder
                        hide-details
                        :readonly="!i.editableByUser"
                      >
                      </v-text-field>
                  </v-col>
                  <template v-else>
                    <v-col cols="8" class="d-flex align-center">
                      {{i.description}}
                    </v-col>
                    <v-col cols="3" class="d-flex align-center">
                      <template v-if="i.dataType=='bit'">
                        <v-switch
                          color="info"
                   
                          v-model="i.value"
                          inset
                          :name="i.optionId"
                          @change="save2($event, i.optionId)"
                          :label="i.value?'Si':'No'"
                          hide-details
                          :readonly="!i.editableByUser"
                          class="mt-0 pt-0"
                        ></v-switch>                      
                      </template>
                      <template v-else>
                        <v-text-field   
           
                          counter
                          label=""
                          :name="i.optionId"
                          outlined
                          @input.native="save"
                          :reverse="i.dataType!='nvarchar'"
                          :stlye="i.dataType=='int'?'max-width:100px':''"
                          v-model="i.value"
                          persistent-placeholder
                          hide-details
                          :readonly="!i.editableByUser"
                        >
                        </v-text-field>                          
                      </template>
                    </v-col>
                  <v-col cols="1" class="d-flex align-center">
                    <v-tooltip max-width="250" top :disabled="!i.help&&!i.editableByUser" v-if="i.help||i.editableByUser">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on"  color="info">mdi-help-circle</v-icon>
                      </template>
                      <span v-html="!i.editableByUser?'Sola Lettura':i.help"></span>
                    </v-tooltip>                          
                  </v-col>                                                
                </v-row>
              </v-card>              
              <v-card class="neu-glow mt-7" :class="$vuetify.breakpoint.xlAndUp?'mb-3':',my-3'">
                <v-card-title class="text-h5 mb-3 blue-grey darken-1">
                  Altri Parametri Prenotazione Online
                </v-card-title>
                <v-row class="mx-2" v-for="(i,ii) in WA_DBS" :key="ii">
                  
                  <v-col cols="11" v-if="i.dataType=='nvarchar'" class="d-flex align-center">
                      <v-text-field   
                        dense
                        :label="i.description"
                        :name="i.optionId"
                        @input.native="save"
                        outlined
                        :reverse="i.dataType!='nvarchar'"
                        v-model="i.value"
                        persistent-placeholder
                        hide-details
                        :readonly="!i.editableByUser"
                      >
                      </v-text-field>
                  </v-col>
                  <template v-else>
                    <v-col cols="8" class="d-flex align-center">
                      {{i.description}}
                    </v-col>
                    <v-col cols="3" class="d-flex align-center">
                      <template v-if="i.dataType=='bit'">
                        <v-switch
                          color="info"
                          dense
                          v-model="i.value"
                          inset
                          :name="i.optionId"
                          @change="save2($event, i.optionId)"
                          :label="i.value?'Si':'No'"
                          hide-details
                          :readonly="!i.editableByUser"
                          class="mt-0 pt-0"
                        ></v-switch>                      
                      </template>
                      <template v-else>
                        <v-text-field   
                          dense
                          counter
                          label=""
                          :name="i.optionId"
                          outlined
                          @input.native="save"
                          :reverse="i.dataType!='nvarchar'"
                          :stlye="i.dataType=='int'?'max-width:100px':''"
                          v-model="i.value"
                          persistent-placeholder
                          hide-details
                          :readonly="!i.editableByUser"
                        >
                        </v-text-field>                          
                      </template>
                    </v-col>
                  <v-col cols="1" class="d-flex align-center">
                    <v-tooltip max-width="250" top v-if="i.help||!i.editableByUser">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on"  color="info">mdi-help-circle</v-icon>
                      </template>
                      <span v-html="!i.editableByUser?'Sola Lettura':i.help"></span>
                    </v-tooltip>                          
                  </v-col>                                                
                </v-row>
              </v-card>
            </v-col>              
          </v-row>
        </v-card>
    </v-form>
    <v-dialog v-model="dialog_instruction" max-width="800">
        <v-card>
            <v-card-title class="text-h5 mb-3">
              WhatsApp: Istruzioni
              <v-spacer></v-spacer>
              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_instruction = false">
                      <v-icon color="info">mdi-close</v-icon>
                  </v-btn>
                  </template>
                  <span>Esci</span>
              </v-tooltip>               
            </v-card-title>
            <v-divider></v-divider>              
            <v-row class="mx-5 mb-0">
                <v-col md="12" cols="12">
                    <p>
                      l'Hostname è l'indirizzo al quale i vostri clienti potranno effettuare le prenotazioni ma anche il punto di ingresso all'App:
                    <br />
                      come default utilizza il nome del vostro sito (o il nome del vostro locale) che avete indicato in fase di registrazione: qualora non sia stato fornito utilizza una stringa casuale (che può comunque essere modificata<sup>1</sup> da questa pagina):
                    </p>
                    <p>
                      Ipotizziamo ad esempio, che il vostro locale si chiami <strong>Arcadia</strong> e/o il vostro sito sia <strong>www.arcadia.it</strong>, il sistema vi attribuirà di default il seguente hostname: <strong>arcadia.jslab.it</strong>
                    </p>
                    <p>
                      E' disponibile, a fronte di un contributo di configurazione una tantum di 100 €, una soluzione del tipo <strong>booking.arcadia.it</strong> (o <strong>qualsiasicosa.arcadia.it</strong>)
                    </p>
                    <p>In quest caso è necessario che:
                      <ul>
                        <li>
                          Creiate un nuovo hostname e lo denominiate come meglio credete, nell'esempio <strong>booking.arcadia.it</strong>
                        </li>
                        <li>
                          Se non avete già un sito, lo registriamo noi a Vostro nome<sup>2</sup>
                          Se invece avete già un sito, inseriate il recapito di colui che gestisce il nome a dominio <strong>arcadia.it</strong> che contatteremo per le necessarie modifiche.
                          <br />In pratica gli chiederemo di creare il sottodominio <strong>booking</strong> e farlo puntare all'indirizzo <strong>84.247.8.202</strong>.
                          <br />(Più tecnicamente creare il seguente DNS Record: <strong>booking 60 IN A 84.247.8.202</strong>)
                        </li>  
                      </ul>
                    <p>
                      Non appena le impostazioni si saranno propagate (il tempo canonico è 24 ore) provvederemo ad apportare le necessarie modifiche di configurazione e l'indirizzo sarà attivo
                    </p>
                    <p>
                      <sup>1</sup>Se non è già utilizzato
                      <sup>2</sup>(dall'anno successivo vi verrà addebitato un canone di 30.00€)
                      </p>
                </v-col>
            </v-row>

        </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_vuecropper" max-width="1100">
      <vuecropper 
        v-if="UFD"
        @close="closeCropper"
        @completed="handleCompleted"
        @error="handlerError"
        :uploadFormData="UFD"
      >
      </vuecropper>
    </v-dialog> 	
  </div>
</template>
<script>
import { mapGetters } from "vuex";
//import AvatarCropper from "../AvatarCropper";
import vuecropper from "../VueCropper";
import _ from 'lodash'
export default {
  components: { vuecropper },
  data() {
    return {
      page: "Settings",
      form:{},
      snackbar:false,
      snackbar_color:null,
      snackbar_message:null,
      loading:false,
      loading_update:false,
      loading_refresh:false,
      wHeight: window.innerHeight,
      wWidth: window.innerWidth,
      dialog_edit:false,
      dialog_instruction:false,
      dialog_vuecropper:false,
      templates_hash:null,
      templates:null,
      subdomain:null,
      UFD:null,
      //pictureType:null,
      editedItem:{},
      uploadURL:'https://ibookrestaurant.com/ajax/settings/upload.php',
      cropperOptions:[
                      {aspectRatio: 1.5, dragMode: 'move',autoCropArea: 0.8,viewMode: 1,movable: true,zoomable: true,center: true,highlight: true,cropBoxMovable: true,cropBoxResizable: true},
                      {aspectRatio: 4, dragMode: 'move',autoCropArea: 0.8,viewMode: 1,movable: true,zoomable: true,center: true,highlight: true,cropBoxMovable: true,cropBoxResizable: true}
                     ],
      outputOptions: [
                        {
                        width: 420,
                        height: 240,
                        minWidth: 420,
                        minHeight: 240,
                        maxWidth: 420,
                        maxHeight: 240,
                        imageSmoothingEnabled: true,
                        imageSmoothingQuality: 'high',
                      },
                      {
                        width: 280,
                        height: 70,
                        minWidth: 280,
                        minHeight: 70,
                        maxWidth: 280,
                        maxHeight: 70,
                        imageSmoothingEnabled: true,
                        imageSmoothingQuality: 'high',
                      }
                    ],      
      pictureName:null,
      pictureNameW:null,
      pictureNameRoot:null,
      pictureNameRootW:null,
      optionId:null,
      changedLogo:false,
      
      selectedTemplate:null,
      brand:null,
      inputFields:[],
      default:{"fullName":"Mario Rossi","day":"Sabato 18 Giugno","time":"20:30","guests":"5+1 Seggiolone","brand":this.brand},
      WA_DB:null,
      WA_DBS:null,
      WA_DBSL:null,                   
    };
  },
  computed : {
    ...mapGetters(["settings"]),
  },
  created(){
    this.getData()
  },
  mounted(){
    //console.log(768,this.$route.query.user)
  },
  watch : {

  },
  methods:
  {
    closeCropper()
    {
      this.dialog_vuecropper=false;
      this.UFD=null;
    },
    handleCompleted({ response,form1 } )
    {
      console.log(388, response,response.data)
      //console.log(185, form1)
      this[form1.name]=response.payload;
      if (response.status=='OK')
      {
        this.changedLogo=true;
        this.snackbar_color='success';
        this.snackbar_message='Modificato Logo';
        this.pictureName=response.pictureName;
        console.log(397,this.pictureName)
      }
      else
      {
        this.snackbar_color='error';
        this.snackbar_message=response.message;
      }
      this.snackbar=true;
    },
    handleError({ message, type, context}) {
      if (type === 'upload') {
        const { request, response } = context
      console.log(409, message, request, response)
      this.snackbar=true;
      this.snackbar_color='error';
      this.snackbar_message=response.message;      
      }
    },         
    setPictureName(i)
    {
      console.log(397,i);
      //this.pictureType=i.optionId.includes('TB')?'tb':'db';
      this.pictureNameRoot=i.value.split('-')[1];
      this.optionId=i.optionId;
      this.path=i.path;
      this.pictureName=i.value.split('-')[1];
      
      this.UFD={'name':i.value,'type':i.path,'subdomain':this.subdomain,'optionId':i.optionId,'width':i.size.split('x')[0],'height':i.size.split('x')[1]}
      console.log(409,this.UFD)
      this.dialog_vuecropper=true

    },
    save: _.debounce(function (event) {
      console.log(400,event.target.name,event.target.value)
      var v=event.target.value
      var value=v===false?0:v===true?1:v===''?null:v
      var pload={"optionId":event.target.name,"value":value};
      //var pload={[event.target.name]:event.target.value};
      var action='saveItem';
      let payload={"action":action,"table":"User_Options","payload":pload};
      console.log(406,payload)
      this.updateDB(payload)
    }, 1000),
    save2(value, field) {
      console.log(410,value, field);
      var pload={"optionId":field,"value":value===false?0:value===true?1:value===''?null:value};
      //var pload={[field]:value===false?0:value===true?1:value===''?null:value};
      //var pload={[field]:value};
      //pload[field]=value;
      var action='saveItem';
      let payload={"action":action,"table":"User_Options","payload":pload};
      console.log(413,payload)
      this.updateDB(payload)
    },    
    async restoreImage(i)
    {
      console.log(427,i);
      this.loading_update=true;
      var action='saveItem';
      var pload={"optionId":i.optionId};
      let payload={"action":action,"table":"User_Options_Restore","payload":pload};
      console.log(413,payload)
      let z= await this.updateDB(payload)
      this.loading_update=false;
      console.log(416,z);
      if(z.errorid=='0')
      {
          this.snackbar_color="success"
          this.message =z.message;
          this.snackbar = true;
          //console.log(422,w.payloads.ivalue)
          this.WA_DB.find(w=>w.optionId==i.optionId).value=z.payloads.ivalue;
          //this.pictureName=z.payloads.ivalue
          //this.dialog_editOption=false;
          //this.slotsByDOW_hash=JSON.stringify(this.slotsByDOW);
      }

    },
    handleUploading({ form, request }) {
      // show a loader
      console.log(384, {form, request})
    },/*
    handleCompleted({ response,form1 } )
    {
      console.log(388, response,response.data)
      //console.log(185, form1)
      this[form1.name]=response.payload;
      if (response.status=='OK')
      {
        this.changedLogo=true;
        this.snackbar_color='success';
        this.snackbar_message='Modificato Logo';
        this.pictureName=response.pictureName;
        this.WA_DB.find(w=>w.optionId==response.optionId).value=response.pictureName;
        console.log(397,this.pictureName)
      }
      else
      {
        this.snackbar_color='error';
        this.snackbar_message=response.message;
      }
      this.snackbar=true;
    },
    handleError({ message, type, context}) {
      if (type === 'upload') {
        const { request, response } = context
      console.log(409, form, request, response)
      this.snackbar=true;
      this.snackbar_color='error';
      this.snackbar_message=response.message;      
      }
    },*/
    editItem(f)
    {
      if (f)
      {
        this.editedItem=f
      }
      else
      {
        this.editedItem={};
        this.editedItem_hash=JSON.stringify(this.editedItem)
      }
      console.log(214,f,this.editedItem)
      this.dialog_edit=true;
    }, 
    editOption(f)
    {
      this.editedOption=f;
      console.log(214,f)
      this.dialog_edit=true;
    },
    async getData(origin)
    {
        {
            if(origin=='refresh')
            {
              this.loading_refresh=true;
            }
            else
            {
              this.loading=true;
            }
            try{
                const payload=JSON.stringify({"date": this.date,"action":"AllDirectBookingOptions_get"});
                const res = await this.$http.post('/settings/settings.php', payload );
                console.log(275,res);
                this.loading_refresh=false;
                this.loading=false;
                switch (res.data.errorid)
                {
                  case '0':
                      sessionStorage.setItem('jwt', res.data.jwt);
                      this.brand=res.data.payloads.WA_Brand.brand;
                      this.subdomain=res.data.payloads.WA_Subdomain.subdomain;
                      this.WA_DB=res.data.payloads.WA_DB.map(o=>{o.value=o.value==='1'&&o.dataType=='bit'?true:(o.value==='0'&&o.dataType=='bit'?false:o.value); return o});
                      this.WA_DBS=res.data.payloads.WA_DBS.map(o=>{o.value=o.value==='1'&&o.dataType=='bit'?true:(o.value==='0'&&o.dataType=='bit'?false:o.value); return o});
                      this.WA_DBSL=res.data.payloads.WA_DBSL.map(o=>{o.value=o.value==='1'&&o.dataType=='bit'?true:(o.value==='0'&&o.dataType=='bit'?false:o.value); return o});
                      /*this.pictureName=this.WA_Options.find(o=>o.optionId=='TDB_Logo').value;
                      this.pictureNameW=this.WA_Options.find(o=>o.optionId=='TWDB_Logo').value;
                      this.pictureNameRoot=this.pictureName.split('-')[1];
                      this.pictureNameRootW=this.pictureNameW.split('-')[1];  
                      */                    
                      console.log(486,this.brand,this.WA_DB,this.WA_DBS,this.subdomain);
                      //console.log(487,this.pictureName,this.pictureNameW,this.pictureNameRoot,this.pictureNameRootW)
                  break;
                  case '0006':
                      this.$router.push('/auth/login').catch(() => {});
                  break;
                }
            } catch(e)
            {
                this.loading= false;
                this.loading_refresh=false;
                this.dialog_connection_error=true;
            }
        }
    },
    async updateDB(payload){
        try{
            const res = await this.$http.post('/settings/settings.php', payload);
            console.log(324,res);
            if (res.data.errorid=='0')
            {
              sessionStorage.setItem('jwt', res.data.jwt);
              this.snackbar_color='success';
              this.snackbar_message=res.data.message;

              if (res.data.message)
              {
                  console.log(333);
                  this.snackbar_color=res.data.status=='OK'?'success':'error';
                  this.snackbar_message=res.data.message;
                  this.snackbar=true;
              }
            }
            else
            {
              this.snackbar_color='error'
              this.snackbar_message=res.data.message;
              this.snackbar=true;
              console.log(342);
            //this.$router.push('/auth/login').catch(() => {});
            }

            //this.$store.dispatch("setUser", res.data.user); 
            return res.data;
        } catch(e)
        {
        console.log(e);
        }
    },
  },
};
</script>